
const tendersModule = {
    namespaced: true,
    state: {
        stats: null,
        type: 'participants',
        modalData: null,
        isModal: false,
        isLoading: false,
        pagination: null,
        productsStat: null,
        tendersList: []
    },
    mutations:{
        changeType(state) { 
            state.type = state.type === 'participants' ? 'customers' : 'participants' 
        }
    },
    actions: {
        getTendersStat({ dispatch, commit }, ogrn) {

            return dispatch('v3/API', {
                method: 'tenders',
                data: {
                    action: 'stats_l',
                    ogrn
                }
            }, { root: true }).then(resp => {
                if(resp.status === 200 && resp.data?.code === 0 && resp.data?.data?.stats) {
                    commit('setStateObject', { name: 'card.tenders.stats', value: resp.data.data.stats }, { root: true })
                    return resp.data.data.stats
                }
            }).catch(err => {
                console.error(err.message)
            })
        },
        getProductsStat({ dispatch, commit }, ogrn) {

            return dispatch('v3/API', {
                method: 'tenders',
                data: {
                    action: 'stats_p',
                    ogrn
                }
            }, { root: true }).then(resp => {
                if(resp.status === 200 && resp.data?.code === 0 && resp.data?.data?.stats) {
                    commit('setStateObject', { name: 'card.tenders.productsStat', value: resp.data.data.stats }, { root: true })
                }
            }).catch(err => {
                console.error(err.message)
            })
        },
        getFullInfo({ dispatch, commit }, { ogrn, year, type, limit = 50, offset = 0 }) {
            commit('setStateObject', { name: 'card.tenders.isLoading', value: true }, { root: true })
            commit('setStateObject', { name: 'card.tenders.modalData', value: { type, year } }, { root: true })
            commit('setStateObject', { name: 'card.tenders.isModal', value: true }, { root: true })

            return dispatch('v3/API', {
                method: 'tenders',
                data: {
                    action: 'full_info',
                    total: true,
                    ogrn,
                    type,
                    year,
                    limit,
                    offset
                }
            }, { root: true }).then(resp => {
                if(resp.status === 200 && resp.data?.code === 0 && resp.data?.data?.list_tenders?.length) {
                    commit('setStateObject', { name: 'card.tenders.tendersList', value: resp.data.data.list_tenders }, { root: true })
                    commit('setStateObject', { name: 'card.tenders.pagination', value: resp.data.data.pagination }, { root: true })
                    commit('setStateObject', { name: 'card.tenders.isLoading', value: false }, { root: true })
                    return resp.data.data.list_tenders
                } else {
                    commit('setStateObject', { name: 'card.tenders.isLoading', value: false }, { root: true })
                }
            }).catch(err => {
                console.error(err.message)
                commit('setStateObject', { name: 'card.tenders.isLoading', value: false }, { root: true })
            })
        },
        closeModal({ commit }) {
            commit('setStateObject', { name: 'card.tenders.isModal', value: false }, { root: true })
            commit('setStateObject', { name: 'card.tenders.modalData', value: null }, { root: true })
            commit('setStateObject', { name: 'card.tenders.pagination', value: null }, { root: true })
        }
    },
    getters: {
        participantYears: state => Object.keys(state.stats?.participant ?? {}).filter(y => !isNaN(Number(y))),
        customerYears: state => Object.keys(state.stats?.customer ?? {}).filter(y => !isNaN(Number(y)))
    }
}

export default tendersModule